import * as actionTypes from './actionTypes';
import * as actions from '../../store/actions/index';
import { axiosPublic } from '../../axios-wizard';
import { axiosProtected } from '../../axios-wizard';

export const getWizardScope = (state) => {
  if (state.wizard !== undefined) {
    return {
      projectscope: state.wizard['projectscope'],
      projectunitscope: state.wizard['projectunitscope'],
    }
  } else {
    return {
      projectscope: '',
      projectunitscope: '',
    }
  }
}

export const getWizardObject = (state) => {
  if (state.wizard !== undefined && state.wizard['selectedSteps'] !== undefined) {
    const x = state.wizard['selectedSteps'];
    return x;
  } else {
    return [];
  }
}

export const getWizardFilterSelectProductSystem = (state) => {
  if (state.wizard !== undefined && state.wizard['productSystemFilters'] !== undefined) {
    const x = state.wizard['productSystemFilters'];
    return x;
  } else {
    return [];
  }
}

export const wizardSetProjectScope = (projectId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: actionTypes.SET_WIZARD_SCOPE_PROJECT,
        value: projectId});
      resolve();
    });
  }
};

export const wizardSetProjectunitScope = (projectunitId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: actionTypes.SET_WIZARD_SCOPE_PROJECTUNIT,
        value: projectunitId});
      resolve();
    });
  }
};

export const wizardReset = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({type: actionTypes.UNSET_WIZARD_COUNTRY});
      resolve();
    });
  }
};



export const wizardSelectCountry = (value) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return dispatch({
          type: actionTypes.SET_WIZARD_COUNTRY,
          stepValue: value,
          nextStep: 'fwk'
      });
    });
  }
};



export const wizardSelectFwk = (value) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return dispatch({
          type: actionTypes.SET_WIZARD_FWK,
          stepValue: value,
          nextStep: 'location'
      })
    }).then( dispatch(actions.eventStartProductSelector()) );
  }
};

export const wizardGoToResults = () => {
  return {
      type: actionTypes.SET_WIZARD_PRODUCT_SYSTEM,
      stepValue: 'direct_results',
      nextStep: 'product_system'
    };
};

export const wizardSelectLocation = (value) => {
  return {
      type: actionTypes.SET_WIZARD_LOCATION,
      stepValue: value,
      nextStep: 'execution_type'
    };
};

export const wizardSelectExecutionType = (value) => {
  return {
      type: actionTypes.SET_WIZARD_EXECUTION_TYPE,
      stepValue: value,
      nextStep: 'medium_type'
    };
};

export const wizardSetMediumType = (value) => {
  return {
      type: actionTypes.SET_WIZARD_MEDIUM_TYPE,
      stepValue: value
    };
};

export const wizardAddMediumType = (value) => {
  return {
      type: actionTypes.ADD_WIZARD_MEDIUM_TYPE,
      stepValue: value
    };
};

export const wizardRemoveMediumType = (value) => {
  return {
      type: actionTypes.REMOVE_WIZARD_MEDIUM_TYPE,
      stepValue: value
    };
};

export const wizardSelectMediumType = (value) => {
  return {
      type: actionTypes.SET_WIZARD_MEDIUM_TYPE,
      nextStep: 'product_system'
    };
};



export const wizardSelectProductSystem = (stepValue, selectedPenetration, selectedInsulation, selectedProductgroup) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return dispatch({
          type: actionTypes.SET_WIZARD_PRODUCT_SYSTEM,
          stepValue: stepValue,
          selectedPenetration: selectedPenetration,
          selectedInsulation: selectedInsulation,
          selectedProductgroup: selectedProductgroup,
          nextStep: 'product_solution'
      })
    }).then( dispatch(actions.eventFinishProductSelector(false)) );
  }
};




export const wizardAddProductSystemItem = (value) => {
  return {
      type: actionTypes.ADD_WIZARD_PRODUCT_SYSTEM_ITEM,
      value: value
    };
};

export const wizardRemoveProductSystemItem = (value) => {
  return {
      type: actionTypes.REMOVE_WIZARD_PRODUCT_SYSTEM_ITEM,
      value: value
    };
};

export const wizardUnsetStep = (stepName) => {
  switch (stepName) {
    case 'country': return {type: actionTypes.UNSET_WIZARD_COUNTRY};
    case 'fwk': return {type: actionTypes.UNSET_WIZARD_FWK};
    case 'location': return {type: actionTypes.UNSET_WIZARD_LOCATION};
    case 'execution_type': return {type: actionTypes.UNSET_WIZARD_EXECUTION_TYPE};
    case 'medium_type': return {type: actionTypes.UNSET_WIZARD_MEDIUM_TYPE};
    default: return {type: 'nothing'}
  }
};


export const fetchOnlyProductSolutionByUid = (uid) => {
    const url = '/api/product_solutions/' + uid

    return dispatch => {
        return axiosPublic.get( url )
            .then( response => { return response.data} ) // return wizard configuration of given product_solution
            .catch( error => {
                //dispatch(fetchProductsystemsFailed());
            } );
    };
};

export const errorOnLoadingSolutionById = () => {
  return {
      type: actionTypes.ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION,
    };
};

export const resetErroOnLoadingSolutionById = () => {
  return {
      type: actionTypes.RESET_ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION,
    };
};


export const fetchProductSolutionByUid = (uid) => {


    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      const url = '/api/product_solutions/' + uid + '/show_intern'
      return dispatch => {
          dispatch( actions.resetErroOnLoadingSolutionById() );

          return axiosProtected.get( url )
              .then( response => { return response.data} ) // return wizard configuration of given product_solution
              .then( response2 => { dispatch(actions.fetchProductsystems( // mit dieser config jetzt die product_systems holen
                {
                  country: response2.product_solution.country,
                  fwk: response2.product_solution.fwk,
                  location: response2.product_solution.installation_location
                })); return response2;}
              )
              .then( (response) => dispatch(setWizardByProductSolution(response)) )
              .catch( error => {
                  dispatch(errorOnLoadingSolutionById());
              } );
      };


    } else {
      const url = '/api/product_solutions/' + uid
      return dispatch => {
          dispatch( actions.resetErroOnLoadingSolutionById() );

          return axiosPublic.get( url )
              .then( response => { return response.data} ) // return wizard configuration of given product_solution
              .then( response2 => { dispatch(actions.fetchProductsystems( // mit dieser config jetzt die product_systems holen
                {
                  country: response2.product_solution.country,
                  fwk: response2.product_solution.fwk,
                  location: response2.product_solution.installation_location
                })); return response2;}
              )
              .then( (response) => dispatch(setWizardByProductSolution(response)) )
              .catch( error => {
                  dispatch(errorOnLoadingSolutionById());
              } );
      };
    }




};



export const setWizardByProductSolution = (res) => {
  const data = res.product_solution;

  return dispatch => {
    return new Promise((resolve, reject) => {
      return dispatch({
          type: actionTypes.SET_WIZARD_BY_PRODUCT_SOLUTION,
          country: data.country,
          fwk: data.fwk,
          location: data.installation_location,
          executionType: data.execution_type,
          mediumTypes: data.medium_types,
          productSystem: data.product_system.id,
          productSystemItems: data.product_system_items,
          token: data.token,
          productSolutionItems: data.product_solution_items,
          holeForm: data.hole_form,
          holeDiameter: data.hole_diameter,
          holeHeight: data.hole_height,
          holeWidth: data.hole_width,
          nextStep: 'product_solution_by_uid'
      })
    })
  }
};





export const fetchFilteredPenetrations = (selectedSteps, penetration_ids, insulation_ids, productgroup_ids) => {
    const url = '/api/penetration_filters/' +
                          '?country=' +  selectedSteps.country +
                          '&fwk=' + selectedSteps.fwk +
                          '&installation_location=' + selectedSteps.location +
                          '&execution_type=' + selectedSteps.executionType +
                          '&medium_type=' + selectedSteps.mediumTypes +
                          '&penetration_ids[]=' + penetration_ids +
                          '&insulation_ids[]=' + insulation_ids +
                          '&productgroup_ids[]=' + productgroup_ids


    return dispatch => {
        //dispatch( fetchProductsystemsStart() );
        return axiosProtected.get( url )
            .then( response => {
               //const normalized = normalize(response.data, { product_systems: schema.arrayOfProductSystems })
               //dispatch(fetchProductsystemsSuccess(normalized));
               return response.data //normalized.result.product_systems
            } )
            .catch( error => {
                //dispatch(fetchProductsystemsFailed());
            } );
    };
};


export const fetchFilteredProductSystems = (penetration_id, selectedSteps) => {
    const selectedStepsHash = selectedSteps || {country: '', fwk: '', location: '', executionType: '', mediumTypes: ''}

    const url = '/api/product_system_filters/?id=' + penetration_id +
                      '&country=' +  selectedStepsHash.country +
                      '&fwk=' + selectedStepsHash.fwk +
                      '&installation_location=' + selectedStepsHash.location +
                      '&execution_type=' + selectedStepsHash.executionType +
                      '&medium_type=' + selectedStepsHash.mediumTypes


    return dispatch => {
        //dispatch( fetchProductsystemsStart() );
        return axiosProtected.get( url )
            .then( response => {
               //const normalized = normalize(response.data, { product_systems: schema.arrayOfProductSystems })
               //dispatch(fetchProductsystemsSuccess(normalized));
               return response.data //normalized.result.product_systems
            } )
            .catch( error => {
                //dispatch(fetchProductsystemsFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/wizard.js